export const ds_ImageLayoutBlock_Entry = `
    fragment ds_ImageLayoutBlock_Entry on ds_ImageLayoutBlock_Entry {
        id
        canonicalUid
        image_ContentAlignment
        image_Padding
        image_Height
        image_CustomHeight
        image_Image {
            alt
            url @transform(width: 1920)
            width
            focalPoint
        }
        image_ImageOriginal: image_Image {
            alt
            url
            width
            focalPoint
        }
    }
`
